// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__JwjI_","container":"styles_container__2C_F_","title":"styles_title__1xBui","wrapper":"styles_wrapper__3ol7g","answer":"styles_answer__1s9Jn"};